import { render, staticRenderFns } from "./AnimatedSwissMap.vue?vue&type=template&id=47dcb64c&"
import script from "./AnimatedSwissMap.vue?vue&type=script&lang=js&"
export * from "./AnimatedSwissMap.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedSwissMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports